import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { initMetaPixel, trackPageView } from '@/lib/metaPixel';
import { initGoogleAnalytics, trackGAPageView } from '@/lib/googleAnalytics';

/**
 * Componente per gestire il Meta Pixel e Google Analytics
 * Inizializza i pixel e traccia le page views
 */
export const MetaPixel = () => {
  const location = useLocation();

  useEffect(() => {
    // Inizializza i pixel al mount (se consenso dato)
    initMetaPixel();
    initGoogleAnalytics();
  }, []);

  useEffect(() => {
    // Traccia ogni cambio di route
    trackPageView();
    trackGAPageView(location.pathname);
  }, [location.pathname]);

  return null;
};

